import type { StoreNudgeCatalogItem } from './isRedeemableNow'

export const STORE_NUDGE_ITEM_PLACEHOLDER = '/placeholders/product-without-image.jpg'

/** Mesma origem que a vitrine usa (`image.file.url`), com o placeholder do catálogo. */
export const itemImageUrl = (item: Pick<StoreNudgeCatalogItem, 'image'>) =>
  item.image?.file?.url || STORE_NUDGE_ITEM_PLACEHOLDER
